import * as React from 'react';
import { observer } from 'mobx-react';
import { currentUserStore } from '../CurrentUserStore';
import GoogleTagManagerTooling from './GoogleTagManagerTooling';
import OneTrustTooling from './OneTrustTooling';

const Tooling: React.FC = () => {
  return (
    <>
      <OneTrustTooling />
      <GoogleTagManagerTooling user={currentUserStore.currentUserState} />
    </>
  );
};

export default observer(Tooling);
